"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumReceivableSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const invoice_status_computed_mapping_1 = require("../base/invoice-status-computed-mapping");
const meta_data_invoice_1 = require("../base/meta-data-invoice");
exports.SourgumReceivableSchema = {
    name: 'sourgum-receivable',
    alias: 'Sourgum Receivable',
    shortName: 'Invoice',
    applications: ['aap', 'customer-portal'],
    disabled: false,
    returnType: {
        aap: transport_types_1.Invoice.ReceivableTransport,
        'customer-portal': transport_types_1.Invoice.CustomerReceivableTransport,
    },
    searchableAttributes: [
        {
            field: 'customerName',
            alias: 'Customer Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'customerCompanyName',
            alias: 'Company',
            shortName: 'Company',
            searchableByDefault: true,
        },
        {
            field: 'customerAccountNumber',
            alias: 'Account Number',
            shortName: 'account_number',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.orderNumber',
            alias: 'Order Number',
            shortName: 'orderNumber',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.invoiceNumber',
            alias: 'Invoice Number',
            shortName: 'invoiceNumber',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.addressLine1',
            alias: 'Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.orderServiceLocation.county',
            alias: 'Service Location County',
            shortName: 'County',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refNumber',
            alias: 'Ref Number',
            shortName: 'Ref Number',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.addressLine1',
            alias: 'Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.addressLine2',
            alias: 'Service Location Address 2',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.state',
            alias: 'Service Location State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.city',
            alias: 'Service Location City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.address.zip',
            alias: 'Service Location Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'invoiceDetails.lineItems.references.entityData.refServiceLocation.county',
            alias: 'Service Location County',
            shortName: 'County',
            searchableByDefault: false,
        },
    ],
    filterableAttributes: [
        {
            type: 'STRING',
            field: 'invoiceDetails.status_computed',
            useKeywordSubfield: false,
            alias: 'Invoice Status',
            shortName: 'Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: {
                aap: transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                    value: status,
                    label: transport_types_1.Invoice.InvoiceStatusLabels[status],
                })),
                'customer-portal': transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                    value: status,
                    label: transport_types_1.Invoice.InvoiceStatusLabels[status],
                })).filter((status) => status.value !== 'DRAFT'),
            },
        },
        {
            type: 'STRING',
            field: 'invoiceDetails.status',
            alias: 'Invoice Status (Legacy - Stale)',
            shortName: 'Status (Legacy)',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: {
                aap: transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                    value: status,
                    label: transport_types_1.Invoice.InvoiceStatusLabels[status],
                })),
                'customer-portal': transport_types_1.Invoice.InvoiceStatuses.map((status) => ({
                    value: status,
                    label: transport_types_1.Invoice.InvoiceStatusLabels[status],
                })).filter((status) => status.value !== 'DRAFT'),
            },
        },
        {
            type: 'NUMBER',
            field: 'invoiceDetails.term',
            alias: 'Term',
            shortName: 'Term',
            allowedOperators: 'ALL',
            format: 'INTEGER',
        },
        {
            type: 'NUMBER',
            field: 'invoiceDetails.total',
            alias: 'Total',
            shortName: 'Amount',
            allowedOperators: 'ALL',
            format: 'MONEY',
        },
        {
            type: 'NUMBER',
            field: 'invoiceDetails.remainingBalance',
            alias: 'Remaining Balance',
            shortName: 'Remaining Balance',
            allowedOperators: 'ALL',
            format: 'MONEY',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.issueDate',
            alias: 'Issue Date',
            shortName: 'Issue Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.dueDate',
            alias: 'Due Date',
            shortName: 'Due Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.refunds.date',
            alias: 'Refund Date',
            shortName: 'Refund Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.payments.paymentReceivedDate',
            alias: 'Payment Date',
            shortName: 'Payment Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'DATE',
            field: 'invoiceDetails.lineItems.references.entityData.startDate',
            alias: 'Start Date',
            shortName: 'Start Date',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        {
            type: 'DATE',
            field: 'invoiceDetails.lineItems.references.entityData.endDate',
            alias: 'End Date',
            shortName: 'End Date',
            allowedOperators: 'ALL',
            format: 'YYYY-MM-DD',
        },
        ...meta_data_invoice_1.MetaDataFiltersInvoice,
    ],
    extraMappings: [invoice_status_computed_mapping_1.InvoiceStatusComputedMapping],
};
//# sourceMappingURL=sourgum-receivable.js.map